import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

type VerificationIconVariant = 'custom-font-icon' | 'svg'

@Component({
  selector: 'bmcore-verify-icon',
  templateUrl: './bmcore-verify-icon.component.html',
  styleUrls: ['./bmcore-verify-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreVerifyIconComponent {
  @Input() variant: VerificationIconVariant = 'custom-font-icon'

  @Input() backgroundColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
